import styled from 'styled-components';

export const FeaturedOnSection = styled.div`
  flex-basis: 50%;
`;
export const FeatureImgContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: 30px;
`;
export const ImgMarquee = styled.div`
  --gap: 1rem;
  display: flex;
  overflow: hidden;
  user-select: none;
  gap: var(--gap);
  div {
    flex-shrink: 0;
    display: flex;
    justify-content: space-around;
    max-width: ${(props) => (props.marqueeOrder === 2 ? '650px' : '850px')};
    gap: var(--gap);
    animation: scroll 10s linear infinite;
    @keyframes scroll {
      from {
        transform: translateX(0);
      }
      to {
        transform: translateX(calc(-100% - var(--gap)));
      }
    }
  }
  @media (min-width: 768px) {
    padding-right: 5%;
  }
`;

export const FeaturedImg = styled.img`
  width: 17%;
`;
export const BlurOverlay = styled.div`
  position: absolute;
  height: 200px;
  width: 52vw;
  left: 47%;
  z-index: 80;
  background: linear-gradient(
    90deg,
    rgba(239, 240, 240, 1) 10%,
    #eff0f054 20%,
    rgb(33 173 173 / 0%) 80%,
    rgba(239, 240, 240, 0.7484243697478992) 90%,
    rgba(239, 240, 240, 1) 100%
  );

  @media (max-width: 1400px) {
    left: 43%;
    width: 56vw;
  }
  @media (max-width: 768px) {
    display: none;
    width: 70px;
    left: 0;
    height: 120px;
  }
`;
export const BlurOverlayRight = styled.div`
  position: absolute;
  height: 200px;
  width: 130px;
  z-index: 80;
  background: linear-gradient(
    -90deg,
    #eff0f0 50%,
    #eff0f0b9 90%,
    #eff0f0b5 50%
  );
  right: 0;
  @media (max-width: 768px) {
    display: none;
    width: 70px;
    height: 120px;
  }
`;
